import EventHeadline from './event-headline'

export default EventHeadline
